import React, { useState, useEffect } from 'react';
import { ApplicationInterface } from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import iconAlert from "url:shared-assets/icons/red/alert.svg"
import {scrollTop} from "../../../helpers/scrolling";

interface Props {
    application: ApplicationInterface;
    save: Function
}


const StepThree: React.FC<Props> = (props: Props) => {
    const [linkedinUrl, setLinkedinUrl] = useState<string>(props.application.linkedinUrl);
    const [errors, setErrors] = useState<number>(0)
    const [errorFields, setErrorFields] = useState<Array<string>>(["", ""])
    const [triedSave, setTriedSave] = useState<boolean>(false)

    useEffect(() => {
        scrollTop()
    }, [])

    useEffect(() => {
        if (triedSave) {
            checkInput()
        }
    }, [linkedinUrl])

    const checkInput = () => {
        let _errors = 0
        const _errorFields = ["", ""]
        if (linkedinUrl.length < 1) {
            _errors++
            _errorFields[1] = "Too short"
        }
        setErrors(_errors)
        setErrorFields(_errorFields)
        return _errors
    }

    const save = () => {
        setTriedSave(true)
        if (checkInput() > 0) {
            console.log('There are errors')
            return
        }
        const _application: ApplicationInterface = props.application
        _application.linkedinUrl = linkedinUrl
        props.save(_application)
    }

    return (
      <>
          <div className="mt-6 text-xl font-medium">Certification</div>

          <div className="mt-6">LinkedIn profile</div>
          <input value={linkedinUrl} placeholder="Linkedin Url"
                 className={"z-input mt-2" + (triedSave && errorFields[1] ? " error" : "")}
                 onChange={(e) => setLinkedinUrl(e.target.value)}/>

          {
            (triedSave && errors > 0) &&
              <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                  <img src={iconAlert} alt="error"/>
                  <div className="ml-2 font-medium">Please make sure all fields are filled out correctly</div>
              </div>
          }


          <CustomButton className="mt-6" onClick={() => save()}>
              Next
          </CustomButton>
      </>
    )
}

export default StepThree